import { getPaypalConfig } from './getPaypalConfig';

/**
 * Todo: add logic to select right service depending on env
 * @returns
 */
const getPaypalServiceHost = () => getPaypalConfig().serviceUrl;

export { getPaypalServiceHost };
